angular.module('landingPage').factory('agreementService', ($http) => ({
  setDefaultMusicAgreement(agreementId) {
    return $http.put('/account/default-music-agreement', {
      agreement_id: agreementId,
      headers: {
        Accept: 'application/json',
      },
    });
  },
}));
